import { auth, db } from './init';
import { REQUEST_TIMEOUT, REQUEST_CONFIG } from "./config";

// Domain and connection checks
export const isProductionDomain = (): boolean => {
  const domain = typeof window !== 'undefined' ? window.location.hostname : '';
  return domain === 'refer.solarinphoenix.com';
};

export const checkOnlineStatus = (): boolean => {
  return typeof navigator !== 'undefined' && navigator.onLine;
};

// Request configuration
export const REQUEST_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 2000,
  REQUEST_TIMEOUT: 15000
};

// Retry logic
export const executeWithRetry = async <T>(operation: () => Promise<T>): Promise<T> => {
  let retries = 0;
  
  while (retries < REQUEST_CONFIG.MAX_RETRIES) {
    try {
      if (!checkOnlineStatus()) {
        throw new Error("You are offline. Please check your connection.");
      }
      
      return await operation();
    } catch (error) {
      retries++;
      if (retries === REQUEST_CONFIG.MAX_RETRIES) throw error;
      await new Promise(resolve => setTimeout(resolve, REQUEST_CONFIG.RETRY_DELAY * retries));
    }
  }
  
  throw new Error("Operation failed after maximum retries");
};

// Helper functions to format user data
export const formatPhoneNumber = (phone: string): string => {
  // Strip all non-numeric characters
  return phone.replace(/\D/g, '');
};

// Auth validation
export const ensureValidAuth = async (): Promise<void> => {
  if (!auth?.currentUser) {
    throw new Error("Not authenticated");
  }
  
  try {
    await auth.currentUser.getIdToken(true);
  } catch (e) {
    console.log("Token refresh failed, logging out");
    await auth.signOut();
    throw new Error("Your session has expired. Please log in again.");
  }
};
